import { State } from '../../types';

export const maryland: State = {
  name: 'Maryland',
  abbreviation: 'MD',
  terms: [
    {
      word: 'Assateague',
      phonetic: 'ASS-uh-teeg',
      // audioUrl: '/audio/assateague.mp3',
      description: 'A barrier island known for its wild horses.'
    },
    {
      word: 'Bowie',
      phonetic: 'BOO-ee',
      // audioUrl: '/audio/bowie.mp3',
      description: 'City in central Maryland'
    },
    {
      word: 'Havre de Grace',
      phonetic: 'HAV-ruh-deh-Grace',
      // audioUrl: '/audio/havre_de_grace.mp3',
      description: 'A town named after the French city, often mispronounced due to its French origin.'
    },
    {
      word: 'Ijamsville',
      phonetic: 'EYE-emz-ville',
      // audioUrl: '/audio/ijamsville.mp3',
      description: 'A community in Frederick County, with a silent "j."'
    },
    {
      word: 'La Plata',
      phonetic: 'La-PLAY-tah',
      // audioUrl: '/audio/la_plata.mp3',
      description: 'A town in Southern Maryland, often mispronounced due to its Spanish origin.'
    },
    {
      word: 'Maryland',
      phonetic: 'MARE-uh-lind',
      // audioUrl: '/audio/maryland.mp3',
      description: 'State name pronunciation'
    },
    {
      word: 'Patapsco',
      phonetic: 'Puh-TAP-sko',
      // audioUrl: '/audio/patapsco.mp3',
      description: 'A river and state park, name derived from Native American language.'
    },
    {
      word: 'Worcester',
      phonetic: 'WOOS-ter',
      // audioUrl: '/audio/worcester.mp3',
      description: 'A county on the Eastern Shore, often mispronounced due to its English origin.'
    }
  ]
};